module.exports = __webpack_public_path__ + "static/img/qianDaMaIcon.459ad37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qianDaMaIcon.png
// module id = Yn90
// module chunks = 2